function Header() {
  return (
    <header className="app-header">
      <img src="cope.gif.webp" alt="React logo" style={{ borderRadius: 50 }} />
      <h1>The Goofy Ahh Quiz 💀</h1>
    </header>
  );
}

export default Header;
